<script setup>
import { Head, usePage } from "@inertiajs/vue3";
import PageHeader from "@/Components/PageHeader.vue";
import PageFooter from "@/Components/PageFooter.vue";
import { Toaster } from "@/Components/ui/sonner";

const {
  props: {
    title,
    name,
    seo_title,
    seo_description,
    siteSettings: { site_name, site_description },
  },
} = usePage();

let siteTitle;
try {
  siteTitle = `${seo_title || title || name} | ${site_name || "ACSEV"}`;
} catch (e) {
  siteTitle = `404 Error - Not Found | ACSEV`;
}

const metaDescription = seo_description || site_description;
</script>

<template>
  <Head>
    <title>{{ siteTitle }}</title>
    <meta name="description" :content="metaDescription" />
    <link rel="icon" type="image/x-icon" href="/favicon.ico" />
  </Head>
  <div class="w-full relative bg-brand-light text-brand-dark-blue">
    <PageHeader />
    <main class="block relative mt-14 min-[1205px]:mt-28 z-0 print:m-0">
      <slot />
    </main>
    <PageFooter />
  </div>
  <Toaster position="top-right" richColors />
</template>

<style scoped></style>
